export default __webpack_public_path__ + "static/cafe_36036-d11d4409735679178abb201743fc1e03.png";